import { Suspense, lazy } from 'react'
import { useMembershipFlow } from './membershipFlowContext'

const MembershipModal = lazy(() => import('./MembershipModal'))

export default function MembershipFlowHost({ workspaceId }: { workspaceId: string }) {
  const { open } = useMembershipFlow()
  if (!open) return null
  return (
    <Suspense fallback={null}>
      <MembershipModal workspaceId={workspaceId} />
    </Suspense>
  )
}
